import AntragsuebersichtTable from "./AntragsuebersichtTable/AntragsuebersichtTable.vue";
import AntragsuebersichtGrafik from "../../../BerichtFoerderantrag/PanelComponents/AntragsuebersichtGrafik/AntragsuebersichtGrafik.vue";

export default {
  AntragsuebersichtTable,
  AntragsuebersichtGrafik,
};
